import React from 'react'
import ReactSwitch from 'react-switch'

const SwitchButton = ({onChange, checked}) => {
    return (
        <ReactSwitch offColor="#DFE0E2" onColor="#EB742E" onChange={onChange} checked={checked} uncheckedIcon={false} checkedIcon={false} offHandleColor={"#47455F"} onHandleColor='#DFE0E2'/>
    )
}

export default SwitchButton
